/* eslint-disable import/prefer-default-export */
import i18n from '@/js/plugins/i18n';
import DependenciesSrv from '@/components/Dependencies/DependenciesSrv';
import { openConstraintMessage } from '@/components/Dependencies/dependencyDialogs';
import useUiMsgboxStore from '@/stores/ui/msgbox';
import useUsersAccessRightStore from '@/stores/users/accessRight';
import usePlanningStore from '../planning';
import usePlanningElementsStore from '../elements';

export function updateDependencies(triggerEl) {
  const { planning } = usePlanningStore();
  const planningElementsStore = usePlanningElementsStore();
  const usersAccessRightStore = useUsersAccessRightStore();
  const optimizeDependencies = usersAccessRightStore.isBusiness && !! planning.config?.optimizeDependencies;
  const changedEls = DependenciesSrv.calculate(planning.elements, planning.visibleTimeline, false, optimizeDependencies);
  if (! changedEls.length) return false;

  function copyChangedElementsValues(newEls) {
    newEls.forEach((el) => {
      const realEl = planningElementsStore.getElement(el.id);
      realEl.setStartTime(el.getStartTime());
      realEl.setEndTime(el.getEndTime());
      realEl.update();
    });
  }

  if (triggerEl && changedEls.find(item => item.id == triggerEl.id && item.getStartTime().isAfter(triggerEl.getStartTime()))) {
    const changedElsReverse = DependenciesSrv.calculate(planning.elements, planning.visibleTimeline, true, optimizeDependencies);
    const uiMsgboxStore = useUiMsgboxStore();
    const $t = i18n.global.t;
    uiMsgboxStore.open({
      title: $t('DEPENDENCIES.ADVANCE_PREDECESSORS'),
      body: $t('DEPENDENCIES.DEPENDENCY_CONSTRAINT'),
      buttons: { ok: $t('DEPENDENCIES.YES_ADVANCE'), cancel: $t('DEPENDENCIES.NO_RESPECT_CONSTRAINT') },
    }).then(() => {
      copyChangedElementsValues(changedElsReverse);
      planningElementsStore.changingElement();
      const changedTriggerEl = triggerEl && changedElsReverse.find(item => item.id == triggerEl.id);
      if (changedTriggerEl) openConstraintMessage(changedTriggerEl);
    }).catch(() => {
      copyChangedElementsValues(changedEls);
      planningElementsStore.changingElement();
    });
  } else {
    copyChangedElementsValues(changedEls);
    planningElementsStore.changingElement();
    const changedTriggerEl = triggerEl && changedEls.find(item => item.id == triggerEl.id);
    if (changedTriggerEl) openConstraintMessage(changedTriggerEl);
  }

  return true;
}
